'use strict';

$(function () {
  $('.slider').slick({
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          arrows: false,
          dots: true
        }
      }
    ]
  });

  $('.social-list').socialLikes();

  AOS.init({
    startEvent: 'DOMContentLoaded',
    easing: 'ease-in-out',
    duration: 1400,
    once: true
  });
});
